import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, UsersResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }
    
     $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
    }
    
     unshare() {
        const accountIds = this.accounts
            .map(({id}) => id);

        this.isSaving = true;
        this.UsersResource
            .deleteUserSharedServiceAccounts(this.companyId, this.companyUser.id,accountIds)
            .then(() => {
                const companyAccounts = this.accountsForCompanyUser;
                const notes=this.userSharedNotes;
                const sharedAccounts= this.userSharedServiceAccounts;
                const filteredAccounts = sharedAccounts.filter(({id}) => !accountIds.includes(id));
                sharedAccounts.splice(0, sharedAccounts.length, ...filteredAccounts);
                this.Alert('success', 'company.user-directories.manage-user.shared-accounts.unshared');

                if (companyAccounts.length || filteredAccounts.length || notes.lenght ) {
                    this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    this.$state.go('company.user-directories.saaspass-users');
                }
            })
            .finally(() => this.isSaving = false)
    }
    
    
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.controller.js